"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const adyen_1 = require("../helper/adyen");
class AdyenPaymentMethodsResponseStore {
    api = new ecommerce_1.AdyenApi(configuration_1.default);
    internalLoading = false;
    // Ensure that we only load the payment methods response once, if multiple payment methods use Adyen.
    promise = null;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalLoading: mobx_1.observable,
            promise: mobx_1.observable,
            isLoading: mobx_1.computed,
            reset: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.internalLoading;
    }
    loadAdyenPaymentMethodsResponse() {
        if (this.promise) {
            return this.promise;
        }
        this.internalLoading = true;
        const promise = this.api
            .getAdyenPaymentMethodsResponse()
            .then((response) => {
            if ('string' === typeof response) {
                return JSON.parse(response);
            }
            return response;
        })
            .then((response) => {
            if ((0, adyen_1.isPaymentMethodsResponse)(response)) {
                return response;
            }
            return null;
        })
            .finally(() => {
            this.internalLoading = false;
            this.promise = null;
        });
        this.promise = promise;
        return promise;
    }
    reset() {
        this.promise = null;
    }
}
exports.default = new AdyenPaymentMethodsResponseStore();
